import ScheduleCalendarGateway from "@/schedule/usecases/schedule-calendar-gateway";
import ScheduleCalendar from "@/schedule/entities/schedule-calendar";
import Period from "@/schedule/entities/period";
import ClientLike from "../client-like";
import formatDate from "@/helpers/formatDate";
import toScheduleCalendar from "./to-schedule-calendar";
import ScheduleCalendarSearchOptions from "@/schedule/usecases/schedule-calendar-search-options";

/**
 * 予定のカレンダーを扱うAPI
 */
export default class ScheduleCalendarApi implements ScheduleCalendarGateway {
  public constructor(private client: ClientLike) {}

  /**
   * 期間で絞り込む
   */
  public async findByPeriod(
    period: Period,
    options: ScheduleCalendarSearchOptions = {}
  ): Promise<ScheduleCalendar[]> {
    const calendars = await this.client.get("get_service_user_schedule.php", {
      ...toPeriodRequest(period),
      serviceRoleId: options.role
    });
    return calendars.map(toScheduleCalendar);
  }

  /**
   * 期間と現場で絞り込む
   * @description 現場の担当者だけ
   */
  public async findByPeriodAndProject(
    period: Period,
    projectId: number
  ): Promise<ScheduleCalendar[]> {
    const calendars = await this.client.get("get_schedules_of_managers.php", {
      ...toPeriodRequest(period),
      projectId
    });
    return calendars.map(toScheduleCalendar);
  }
}

function toPeriodRequest(period: Period) {
  return {
    start: formatDate(period.start),
    end: formatDate(period.end)
  };
}
